import { connect } from "react-redux";

import AnswerQuestion from "components/answer/AnswerQuestion";

import {
  setNextQuestion,
  setPrevQuestion,
  setCurrentQuestion,
  set as setQuestions
} from "redux/modules/answer/answerQuestion";
import {
  setBasicResult,
  setAdditionResult,
  setDevelopResult
} from "redux/modules/answer/answerResult";

import {
  setHeaderInfo,
  startEffect,
  finishEffect
} from "redux/modules/answer/answerHeader";
import { set as setCustomerLocale } from "redux/modules/answer/attributeReady";
import { set as setSurveyAttrs } from "redux/modules/answer/answerAttribute";
import { openErrorDialog } from "redux/modules/errorDialog";

import history from "utils/history";
import storage from "utils/storage";
import api from "api";

const mapStateToProps = state => ({
  answerHeader: state.answerHeader,
  answerQuestion: state.answerQuestion,
  isEffecting: state.answerHeader.isEffecting,
  locale: state.answerResult.locale,
  answerStart: state.answerStart,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  // 開発用
  set: () => {
    const params = {
      localeId: storage.getAnswerLocaleId(),
      urlToken: storage.getUrlToken()
    };

    api
      .get("attr_ready", params)
      .then(res => {
        dispatch(setHeaderInfo(res.headerInfo));
        dispatch(setCustomerLocale(res.customerLocale));
        dispatch(setSurveyAttrs(res.surveyAttrs));
        dispatch(setQuestions(res.basicQuestions, res.additions));
      })
      .catch(error => dispatch(openErrorDialog(error)));
  },
  showErrorDialog: () => {
    dispatch(openErrorDialog(new Error("invalidOperation")));
  },
  clickBasicBtn: (currentQuestion, num, questionCount) => {
    // ここで回答を記録する
    dispatch(setBasicResult(currentQuestion, num));

    // ボタンのエフェクトを待つ
    dispatch(startEffect());
    setTimeout(() => {
      if (currentQuestion.qNo < questionCount) {
        dispatch(setNextQuestion());
      } else {
        history.push("/other", ownProps);
      }

      dispatch(finishEffect());
    }, 300);
  },
  clickAdditionBtn: (currentQuestion, choice, questionCount) => {
    // ここで回答を記録する
    dispatch(setAdditionResult(currentQuestion, choice));

    // ボタンのエフェクトを待つ
    dispatch(startEffect());
    setTimeout(() => {
      if (currentQuestion.qNo < questionCount) {
        dispatch(setNextQuestion());
      } else {
        history.push("/other", ownProps);
      }

      dispatch(finishEffect());
    }, 300);
  },
  handlePrevBtn: qNo => {
    dispatch(startEffect());

    setTimeout(() => {
      if (qNo > 1) {
        dispatch(setPrevQuestion());
      } else {
        ownProps.history.goBack();
      }

      dispatch(finishEffect());
    }, 300);
  },
  handleDevBtn: qNo => () => {
    dispatch(setDevelopResult(qNo));
    dispatch(setCurrentQuestion(qNo));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(AnswerQuestion);



// WEBPACK FOOTER //
// ./src/containers/preview/AnswerQuestionContainer.js